import { render, staticRenderFns } from "./blackUfw.vue?vue&type=template&id=96571150&scoped=true"
import script from "./blackUfw.vue?vue&type=script&lang=js"
export * from "./blackUfw.vue?vue&type=script&lang=js"
import style0 from "./blackUfw.vue?vue&type=style&index=0&id=96571150&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96571150",
  null
  
)

export default component.exports